import React from 'react';
import Icon from '../../../components/AppIcon';
import { setGeneratedImageDragData } from '../../../utils/dragDropUtils';

const ResultDisplay = ({
  currentImage,
  setCurrentImage,
  isGenerating,
  generationError,
  setGenerationError,
  onDownload,
  onRegenerate
}) => {
  return (
    <div className="glassmorphic-card rounded-3xl p-4 relative">
      <div className="flex justify-end items-center mb-3 px-2">
        <span className="text-white/70 text-sm">Result</span>
      </div>
      <div className="relative rounded-2xl overflow-hidden bg-black/40 h-[400px]">
        {isGenerating ? (
          <div className="w-full h-full flex items-center justify-center">
            <div className="text-center">
              <Icon
                name="Loader"
                size={48}
                className="text-orange-500 mx-auto mb-3 animate-spin"
              />
              <p className="text-white text-sm font-medium">
                Generating your CAD room...
              </p>
              <p className="text-white/60 text-xs mt-1">
                This may take a moment
              </p>
            </div>
          </div>
        ) : currentImage ? (
          <img
            src={currentImage}
            alt="Generated CAD mood room"
            className="w-full h-full object-contain cursor-grab active:cursor-grabbing"
            draggable
            onDragStart={(e) => setGeneratedImageDragData(e, currentImage)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <div className="text-center">
              <Icon
                name="Image"
                size={48}
                className="text-white/30 mx-auto mb-3"
              />
              <p className="text-white/50 text-sm">
                No image generated yet
              </p>
              <p className="text-white/30 text-xs mt-1">
                Upload images and click Generate
              </p>
            </div>
          </div>
        )}

        {/* Action buttons — always visible */}
        <div className="absolute bottom-4 right-4 flex gap-2">
          <button
            onClick={onDownload}
            disabled={!currentImage || isGenerating}
            className="p-2.5 rounded-lg bg-black/70 hover:bg-black/80 border border-white/30 shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            title="Download">
            <Icon name="Download" size={18} className="text-white" />
          </button>
          <button
            onClick={() => setCurrentImage(null)}
            disabled={!currentImage || isGenerating}
            className="p-2.5 rounded-lg bg-black/70 hover:bg-black/80 border border-white/30 shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            title="Delete">
            <Icon name="Trash2" size={18} className="text-white" />
          </button>
          <button
            onClick={onRegenerate}
            disabled={!currentImage || isGenerating}
            className="p-2.5 rounded-lg bg-black/70 hover:bg-black/80 border border-white/30 shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            title="Regenerate">
            <Icon name="RefreshCw" size={18} className="text-white" />
          </button>
        </div>

        {/* Error message overlay */}
        {generationError && !isGenerating && (
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center">
            <div className="text-center max-w-md px-4">
              <Icon name="AlertCircle" size={48} className="text-red-500 mx-auto mb-3" />
              <p className="text-red-400 text-sm font-medium mb-2">Generation Failed</p>
              <p className="text-white/70 text-xs">{generationError}</p>
              <button
                onClick={() => setGenerationError('')}
                className="mt-3 px-4 py-2 bg-red-500/20 hover:bg-red-500/30 border border-red-500/50 rounded-lg text-red-400 text-sm transition-colors">
                Dismiss
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResultDisplay;